/**
 * Audience List Constants
 */

export const DEFAULT_CELL_WIDTH = '150px';

export const COLUMNS = {
  CHECKBOX: 'checkbox',
  NAME: 'name',
  RELATIVE_INTEREST_LEVEL: 'relativeInterestLevel',
  MAJOR: 'major',
  GENDER: 'gender',
  ETHNICITY: 'ethnicity',
  MOST_INTERESTED_SCHOOL: 'mostInterestedSchool',
  VISITS: 'visits',
  VISITOR_TYPE: 'visitorType',
  ENROLL: 'enroll',
  TIME_SPENT_ON_SITE: 'timeSpentOnSite',
  TIME_SPENT_IN_EXPERIENCE: 'timeSpentInExperience',
  MOST_VISITED_SCHOOL: 'mostVisitedSchool',
  LAST_ACTIVE: 'lastActive',
  LOCATION: 'location',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
  DATE_OF_BIRTH: 'dateOfBirth',
  LAST_DATE_OTHER_INSTITUTION: 'lastDateOtherInstitution',
  LATEST_ACTIVITY: 'lastDateActiveWithYouvisit',
  SAT: 'sat',
  ACT: 'act',
  GPA: 'gpa',
  PHONE: 'phone',
  EMAIL: 'email',
  CURRENT_SCHOOL: 'currentSchool',
  HAS_SCHEDULED_VISIT: 'hasScheduledVisitAllTime',
  HAS_APPLIED: 'hasAppliedAllTime',
  POSTAL: 'postal',
  ATTRIBUTES: 'attributes',
  CREATED_BY: 'createdBy',
  LEADS: 'leads',
  LAST_MODIFIED: 'lastModified',
  PRIVACY: 'privacy',
  LEVEL_OF_STUDY: 'levelOfStudy',
  DATE_REGISTERED: 'dateRegistered',
  LOCATION_REGISTERED: 'locationRegistered',
  GUARDIAN_NAME: 'parentFullName',
  GUARDIAN_PHONE: 'parentPhone',
  GUARDIAN_EMAIL: 'parentEmail',
  PERSONALIZATION_PREFERENCES: 'personalizationPreferences',
  PERSONALIZATION_SUGGESTIONS: 'personalizationSuggestions',
};

export interface IColumnConfig {
  title: string;
  width?: string;
  isSortable?: boolean;
  sortKey?: string;
  direction?: string;
  toolTip?: string;
  widthInPixels?: number;
}

export const AUDIENCE_COLUMN_CONFIG = {
  [COLUMNS.CHECKBOX]: <IColumnConfig>{
    title: '',
    widthInPixels: 16,
  },
  [COLUMNS.NAME]: <IColumnConfig>{
    title: 'Name',
    widthInPixels: 210,
    isSortable: true,
    /// sortKey: COLUMNS.NAME,
    sortKey: COLUMNS.NAME,
    toolTip: 'Visitor’s Name',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -40,
  },
  [COLUMNS.LEVEL_OF_STUDY]: <IColumnConfig>{
    title: 'Level of Study',
    toolTipWidth: 300,
    widthInPixels: 108,
    isSortable: true,
    sortKey: COLUMNS.LEVEL_OF_STUDY,
    toolTip: 'Visitor’s Intended Level of Study (Undergraduate vs. Graduate)',
    toolTipMoveTop: -58,
    toolTipMoveLeft: -90,
  },
  [COLUMNS.DATE_REGISTERED]: <IColumnConfig>{
    title: 'Date Registered',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.DATE_REGISTERED,
    toolTip:
      'Date of visitor’s most recent inquiry form submission for your institution via EAB',
    toolTipMoveTop: -76,
    toolTipMoveLeft: -30,
  },
  [COLUMNS.LOCATION_REGISTERED]: <IColumnConfig>{
    title: 'Location Registered',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.LOCATION_REGISTERED,
    toolTip: "User's registered location",
    toolTipMoveTop: -30,
    toolTipMoveLeft: -15,
  },
  [COLUMNS.HAS_SCHEDULED_VISIT]: <IColumnConfig>{
    title: 'Schedule Visit CTA Clicked',
    widthInPixels: 138,
    toolTipWidth: 300,
    isSortable: true,
    sortKey: COLUMNS.HAS_SCHEDULED_VISIT,
    toolTip:
      'Visitor used the “Schedule Visit” CTA button in your institution’s Virtual Tours and/or IWCs (True, False)',
    toolTipMoveTop: -76,
    toolTipMoveLeft: -55,
  },
  [COLUMNS.HAS_APPLIED]: <IColumnConfig>{
    title: 'Apply Now CTA Clicked',
    widthInPixels: 106,
    toolTipWidth: 250,
    isSortable: true,
    sortKey: COLUMNS.HAS_APPLIED,
    toolTip:
      'Visitor used the “Apply Now” CTA button in your institution’s Virtual Tours and/or IWCs (True, False)',
    toolTipMoveTop: -76,
    toolTipMoveLeft: -60,
  },
  [COLUMNS.RELATIVE_INTEREST_LEVEL]: <IColumnConfig>{
    title: 'Relative Engagement',
    widthInPixels: 90,
    toolTipWidth: 200,
    isSortable: true,
    sortKey: COLUMNS.RELATIVE_INTEREST_LEVEL,
    toolTip:
      'Visitor’s relative level of engagement in your institution relative to other institutions and to other visitors (High, Medium, Low)',
    toolTipMoveTop: -112,
    toolTipMoveLeft: -50,
  },
  [COLUMNS.MAJOR]: <IColumnConfig>{
    title: 'Intended Major',
    widthInPixels: 136,
    isSortable: true,
    sortKey: COLUMNS.MAJOR,
    toolTip: 'Prospect’s Intended Major',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -20,
  },
  [COLUMNS.MOST_INTERESTED_SCHOOL]: <IColumnConfig>{
    title: 'Most Interested School',
    widthInPixels: 210,
    isSortable: true,
    sortKey: COLUMNS.MOST_INTERESTED_SCHOOL,
    toolTip: 'Most Interested School',
  },
  [COLUMNS.VISITS]: <IColumnConfig>{
    title: '# of visits',
    widthInPixels: 54,
    isSortable: true,
    sortKey: COLUMNS.VISITS,
    toolTip: 'Number of visits',
  },
  [COLUMNS.GENDER]: <IColumnConfig>{
    title: 'Gender',
    widthInPixels: 90,
    isSortable: true,
    sortKey: COLUMNS.GENDER,
    toolTip: 'Visitor’s Gender',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -15,
  },
  [COLUMNS.ETHNICITY]: <IColumnConfig>{
    title: 'Ethnicity',
    widthInPixels: 146,
    isSortable: true,
    sortKey: COLUMNS.ETHNICITY,
    toolTip: 'Visitor’s Ethnicity',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -15,
  },
  [COLUMNS.VISITOR_TYPE]: <IColumnConfig>{
    title: 'Visitor Type',
    isSortable: true,
    sortKey: COLUMNS.VISITOR_TYPE,
    widthInPixels: 132,
    toolTip:
      'Visitor’s self-identification from your institution’s inquiry form',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -125,
  },
  [COLUMNS.MOST_VISITED_SCHOOL]: <IColumnConfig>{
    title: 'Most Visited School',
    widthInPixels: 90,
    isSortable: true,
    sortKey: COLUMNS.MOST_VISITED_SCHOOL,
    toolTip: 'Most visited school',
  },
  [COLUMNS.ENROLL]: <IColumnConfig>{
    title: 'Entry Term',
    widthInPixels: 88,
    toolTipWidth: 190,
    isSortable: true,
    sortKey: COLUMNS.ENROLL,
    toolTip: 'Prospect’s intended enrollment Year and/or Term',
    toolTipMoveTop: -58,
    toolTipMoveLeft: -42,
  },
  [COLUMNS.LOCATION]: <IColumnConfig>{
    title: 'Location',
    widthInPixels: 88,
    toolTipWidth: 240,
    isSortable: true,
    sortKey: COLUMNS.LOCATION,
    toolTip:
      'Visitor’s Place of Origin. (USA Visitors: “City, State”,  Non-USA visitors: “Country Code”)',
    toolTipMoveTop: -76,
    toolTipMoveLeft: -75,
  },
  [COLUMNS.CITY]: <IColumnConfig>{
    title: 'City',
    widthInPixels: 86,
    toolTipWidth: 240,
    isSortable: true,
    sortKey: COLUMNS.CITY,
    toolTip: 'Visitor’s City (US residents only)',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -65,
  },
  [COLUMNS.STATE]: <IColumnConfig>{
    title: 'State',
    widthInPixels: 38,
    toolTipWidth: 240,
    isSortable: true,
    sortKey: COLUMNS.STATE,
    toolTip: 'Visitor’s State (US residents only)',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -65,
  },
  [COLUMNS.COUNTRY]: <IColumnConfig>{
    title: 'Country',
    widthInPixels: 69,
    toolTipWidth: 240,
    isSortable: true,
    sortKey: COLUMNS.COUNTRY,
    toolTip: 'Visitor’s Country',
    toolTipMoveTop: -25,
    toolTipMoveLeft: -25,
  },
  [COLUMNS.DATE_OF_BIRTH]: <IColumnConfig>{
    title: 'Date of Birth',
    widthInPixels: 89,
    isSortable: true,
    sortKey: COLUMNS.DATE_OF_BIRTH,
    toolTip: 'Visitor’s Date of Birth',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -12,
  },
  [COLUMNS.LAST_DATE_OTHER_INSTITUTION]: <IColumnConfig>{
    title: 'Last Visited Other Institution',
    widthInPixels: 131,
    isSortable: true,
    sortKey: COLUMNS.LAST_DATE_OTHER_INSTITUTION,
    toolTip: 'Last Visited Other Institution',
  },
  [COLUMNS.TIME_SPENT_ON_SITE]: <IColumnConfig>{
    title: 'Time Spent on Site',
    widthInPixels: 54,
    isSortable: true,
    sortKey: COLUMNS.TIME_SPENT_ON_SITE,
    toolTip: 'Time Spent on Site',
  },
  [COLUMNS.TIME_SPENT_IN_EXPERIENCE]: <IColumnConfig>{
    title: 'Time Spent in Experience',
    widthInPixels: 54,
    isSortable: true,
    sortKey: COLUMNS.TIME_SPENT_IN_EXPERIENCE,
    toolTip: 'Time Spent in Experience',
  },

  [COLUMNS.LATEST_ACTIVITY]: <IColumnConfig>{
    title: "Date Last Active in EAB's Network",
    widthInPixels: 131,
    toolTipWidth: 300,
    isSortable: true,
    sortKey: COLUMNS.LATEST_ACTIVITY,
    toolTip:
      'Date of visitor’s most recent activity in EAB’s Network, including any institution’s Virtual Tours or IWCs',
    toolTipMoveTop: -76,
    toolTipMoveLeft: -75,
  },

  [COLUMNS.SAT]: <IColumnConfig>{
    title: 'SAT',
    widthInPixels: 36,
    isSortable: true,
    sortKey: COLUMNS.SAT,
    toolTip: 'Prospect’s SAT score',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -62.5,
  },

  [COLUMNS.ACT]: <IColumnConfig>{
    title: 'ACT',
    isSortable: true,
    sortKey: COLUMNS.ACT,
    widthInPixels: 28,
    toolTip: "Prospect's ACT score",
    toolTipMoveTop: -40,
    toolTipMoveLeft: -38,
  },

  [COLUMNS.GPA]: <IColumnConfig>{
    title: 'GPA',
    widthInPixels: 34,
    isSortable: true,
    sortKey: COLUMNS.GPA,
    toolTip: "Prospect's GPA score",
    toolTipMoveTop: -40,
    toolTipMoveLeft: -39,
  },

  [COLUMNS.PHONE]: <IColumnConfig>{
    title: 'Phone',
    widthInPixels: 100,
    isSortable: true,
    sortKey: COLUMNS.PHONE,
    toolTip: 'Visitor’s Phone Number',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -40,
  },
  [COLUMNS.EMAIL]: <IColumnConfig>{
    title: 'Email',
    widthInPixels: 210,
    isSortable: true,
    sortKey: COLUMNS.EMAIL,
    toolTip: 'Visitor’s Email Address',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -38,
  },

  [COLUMNS.CURRENT_SCHOOL]: <IColumnConfig>{
    title: 'School Name',
    widthInPixels: 210,
    isSortable: true,
    sortKey: COLUMNS.CURRENT_SCHOOL,
    toolTip:
      'Name of School that visitor most recently or currently associates with as a student, graduate, or employee',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -240,
  },

  [COLUMNS.POSTAL]: <IColumnConfig>{
    title: 'Postal Code',
    widthInPixels: 54,
    isSortable: true,
    sortKey: COLUMNS.POSTAL,
    toolTip: 'Visitor’s Postal Code (if applicable)',
    toolTipMoveTop: -40,
    toolTipMoveLeft: -70,
  },

  [COLUMNS.LAST_ACTIVE]: <IColumnConfig>{
    title: 'Date Last Visited My Institution',
    widthInPixels: 131,
    toolTipWidth: 300,
    isSortable: true,
    sortKey: COLUMNS.LAST_ACTIVE,
    toolTip:
      'Date of visitor’s most recent activity with your institution’s Virtual Tours or IWCs',
    toolTipMoveTop: -58,
    toolTipMoveLeft: -75,
  },
  [COLUMNS.GUARDIAN_NAME]: <IColumnConfig>{
    title: 'Guardian Name',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.GUARDIAN_NAME,
    toolTip: 'Guardian name',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -15,
  },

  [COLUMNS.GUARDIAN_PHONE]: <IColumnConfig>{
    title: 'Guardian Phone',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.GUARDIAN_PHONE,
    toolTip: 'Guardian Phone',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -15,
  },

  [COLUMNS.GUARDIAN_EMAIL]: <IColumnConfig>{
    title: 'Guardian Email',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.GUARDIAN_EMAIL,
    toolTip: 'Guardian Email',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -15,
  },
  [COLUMNS.PERSONALIZATION_PREFERENCES]: <IColumnConfig>{
    title: 'Personalization Preferences',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.PERSONALIZATION_PREFERENCES,
    toolTip: 'Personalization Preferences',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -15,
  },
  [COLUMNS.PERSONALIZATION_SUGGESTIONS]: <IColumnConfig>{
    title: 'Personalization Suggestions',
    widthInPixels: 92,
    toolTipWidth: 195,
    isSortable: true,
    sortKey: COLUMNS.PERSONALIZATION_SUGGESTIONS,
    toolTip: 'Personalization Suggestions',
    toolTipMoveTop: -30,
    toolTipMoveLeft: -15,
  },
};

export const LIST_COLUMN_CONFIG = {
  [COLUMNS.NAME]: <IColumnConfig>{
    title: 'List Name',
    width: '346px',
    isSortable: true,
    sortKey: COLUMNS.NAME,
  },
  [COLUMNS.ATTRIBUTES]: <IColumnConfig>{
    title: 'List Attributes',
    width: '309px',
  },
  [COLUMNS.CREATED_BY]: <IColumnConfig>{
    title: 'Created By',
    width: '148px',
    isSortable: true,
    sortKey: COLUMNS.CREATED_BY,
  },
  [COLUMNS.LEADS]: <IColumnConfig>{
    title: '# of Inquiries',
    width: '103px',
    isSortable: true,
    sortKey: COLUMNS.LEADS,
  },
  [COLUMNS.PRIVACY]: <IColumnConfig>{
    title: 'Privacy',
    width: '110px',
    isSortable: true,
    sortKey: COLUMNS.PRIVACY,
  },
  [COLUMNS.LAST_MODIFIED]: <IColumnConfig>{
    title: 'Last Modified',
    width: '110px',
    isSortable: true,
    sortKey: COLUMNS.LAST_MODIFIED,
  },
};

export const SELECT_COLUMN_CONFIG = {
  [COLUMNS.CHECKBOX]: <IColumnConfig>{ title: '', width: '15px' },
  [COLUMNS.NAME]: <IColumnConfig>{
    title: 'List Name',
    width: '430px',
    isSortable: true,
    sortKey: COLUMNS.NAME,
  },
  [COLUMNS.LEADS]: <IColumnConfig>{
    title: '# of Inquiries',
    width: '110px',
    isSortable: true,
    sortKey: COLUMNS.LEADS,
  },
  [COLUMNS.LAST_MODIFIED]: <IColumnConfig>{
    title: 'Last Modified',
    width: '110px',
    isSortable: true,
    sortKey: COLUMNS.LAST_MODIFIED,
  },
};
try {
    // @ts-ignore
    DEFAULT_CELL_WIDTH.displayName = "DEFAULT_CELL_WIDTH";
    // @ts-ignore
    DEFAULT_CELL_WIDTH.__docgenInfo = { "description": "Audience List Constants", "displayName": "DEFAULT_CELL_WIDTH", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Lists/constants.ts#DEFAULT_CELL_WIDTH"] = { docgenInfo: DEFAULT_CELL_WIDTH.__docgenInfo, name: "DEFAULT_CELL_WIDTH", path: "src/shared/components/Lists/constants.ts#DEFAULT_CELL_WIDTH" };
}
catch (__react_docgen_typescript_loader_error) { }